import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { CopyIcon } from '$common/icons/copy'
import { OpenInNewIcon } from '$common/icons/open-in-new'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { t } from '$i18n'
import { copyToClipboard } from '$func/clipboard'
import { showLinkSavedInMemorySnackbar } from '$comp/snackbars'
import { handleLink } from '$logic/router/url'

interface Props {
  isOpen: boolean
  link: string
}

export function LinkMenu({ isOpen, link }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.common.copy')}
        onClick={async () => {
          copyToClipboard(link)
          await closeCurrentModal()
          showLinkSavedInMemorySnackbar()
          analite('CHAT_MESSAGE_COPY_LINK')
        }}
      >
        <CopyIcon />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('menu.link.open')}
        onClick={async () => {
          await closeCurrentModal()
          await handleLink(link)
        }}
      >
        <OpenInNewIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
